import i18next from 'i18next';
import React from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';

import { canCreateExternalClient } from '@selectors/actions/externalClientActions';

export const getActions = ({ selectedItems, authorizedActions, onCreate, onExport }) => {
  const hasSelectedItems = !!selectedItems.length;

  const actions = [
    {
      id: 'action-export',
      actionLabel: i18next.t(hasSelectedItems ? 'GENERAL.EXPORT_SELECTION' : 'GENERAL.EXPORT_LIST'),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
      handleAction: onExport,
    },
  ];

  if (canCreateExternalClient(authorizedActions)) {
    actions.push({
      id: 'action-create',
      fixed: true,
      actionLabel: i18next.t('GENERAL.CREATE'),
      handleAction: onCreate,
      render: () => (
        <Button
          color={'inpulse-default'}
          handleClick={onCreate}
          icon={'/images/inpulse/add-white-small.svg'}
          label={i18next.t('GENERAL.CREATE')}
        />
      ),
    });
  }

  return actions;
};

export const getRowActions = ({ onExportCatalog, onDelete, canDelete }) => {
  const rowActions = [
    {
      id: 'export-catalog',
      actionLabel: () => i18next.t('EXTERNAL_CLIENTS.LIST.EXPORT_CATALOG'),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
      handleAction: onExportCatalog,
    },
  ];

  if (canDelete) {
    rowActions.push({
      id: 'delete-client',
      actionLabel: () => i18next.t('EXTERNAL_CLIENTS.LIST.DELETE_CLIENT'),
      actionIcon: () => '/images/inpulse/trash-black-small.svg',
      handleAction: onDelete,
    });
  }

  return rowActions;
};
